import {Component, OnInit, ViewChild, ElementRef, AfterViewInit, QueryList, ViewChildren} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {NgxLinkifyOptions} from 'ngx-linkifyjs';
import {PlayerService} from '../../core/services/player/player.service';

import {Show, Archive, ArchiveCategory, ArchiveResponse} from '../../../services/archive.model';

@Component({
    selector: 'app-news',
    templateUrl: './news.component.html',
    styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit, AfterViewInit {

    public playerEnabled = !(window.location.hostname === environment.iOSAppDomain);

    public archive: Archive = undefined;
    public isPlaying = false;
    public playingShowId: number = null;

    @ViewChildren('descriptionDiv') descriptionDivs: QueryList<ElementRef>;
    
    public isContentOverflowing(element: HTMLElement): boolean {
        if (!element) return false;
        return element.scrollHeight > element.clientHeight;
    }
    
    private checkForOverflow(): void {
        // Give time for content to render properly
        setTimeout(() => {
            if (this.descriptionDivs) {
                this.descriptionDivs.forEach(divRef => {
                    const div = divRef.nativeElement;
                    const isOverflowing = div.scrollHeight > div.clientHeight;
                    const afterGradient = div.querySelector('.after-gradient');
                    if (afterGradient) {
                        if (isOverflowing) {
                            afterGradient.classList.add('visible');
                        } else {
                            afterGradient.classList.remove('visible');
                        }
                    }
                });
            }
        }, 100);
    }

    constructor(private http: HttpClient, private playerService: PlayerService) {
        this.playerService.isPlaying.subscribe(isPlaying => this.isPlaying = isPlaying);
    }

    public getArtwork(path: string) {
      return 'url(\'' + path + '\')';
    }

    public getCatQueryParams(cat: ArchiveCategory) {
        return { [cat.type]: cat.name };
    }

    public linkifyOptions: NgxLinkifyOptions = {
      target: {
        url: '_blank'
      },
      format(value: string, type: string): any {
        if (type === 'url') {
          value = value.replace('https://', '')
            .replace('http://', '')
            .replace('www.', '');
        }

        return value;
      }
    };

    public play(show: Show) {
        if (!this.isPlaying || this.playingShowId !== show.id) {
          if (this.playingShowId === show.id) {
            this.playerService.play();
          } else {
            this.playingShowId = show.id;
            this.playerService.playFromArchive(show);
          }
        } else {
          this.playingShowId = null;
          this.playerService.pause();
        }
    }


    loadLatestShows(): void {
        this.http.get(
          environment.cmsUrl + environment.routes.getArchive + '?page=1'
        ).subscribe((data: ArchiveResponse) => {
          if (data.status) {
            if (!environment.production) {
              const title = ('Latest Uploads');
              const render = {};
              render[title] = data;
              console.log(render);
            }

            const slice = data.archive.data.slice(0, 4);
            data.archive.data = slice;
            this.archive = data.archive;
            
            // Check for overflow after content is loaded
            setTimeout(() => this.checkForOverflow(), 300);
          } else {
            console.log(data.message);
          }
      });
    }

    ngOnInit(): void {
        this.loadLatestShows();
    }
    
    ngAfterViewInit(): void {
        this.checkForOverflow();
        
        // Recheck overflow whenever data changes or window is resized
        this.descriptionDivs.changes.subscribe(() => {
            this.checkForOverflow();
        });
        
        window.addEventListener('resize', () => {
            this.checkForOverflow();
        });
    }

}
